import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetotrimbkeshwarcab() {



  const cardData = {




keyword: "Pune to Trimbakeshwar Cab Service",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Trimbakeshwar Cab Service for devotees, families, senior citizens, couples, and groups planning a convenient pilgrimage journey. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for one-way travel, round trips, temple visits, family journeys, and customized religious tours. With experienced drivers, clean and well-maintained vehicles, comfortable seating, spacious luggage areas, flexible pickup locations across Pune, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes travel from Pune to Trimbakeshwar convenient and comfortable. Travelers can also customize their itinerary to visit important temples, ghats, heritage attractions, spiritual destinations, and scenic locations around Trimbakeshwar and Nashik.",

topPlaces: [
  {
    title: "Trimbakeshwar Temple",
    description: "Trimbakeshwar Temple is one of the twelve Jyotirlingas of Lord Shiva and is among the most important pilgrimage destinations in Maharashtra. Devotees travel from Pune throughout the year for darshan and religious ceremonies. Garud Cab Service provides private chauffeur-driven cabs with convenient pickup and drop arrangements for a comfortable pilgrimage journey."
  },
  {
    title: "Brahmagiri Hill",
    description: "Brahmagiri Hill is an important spiritual and natural landmark near Trimbakeshwar and is traditionally associated with the origin of the Godavari River. The surrounding Sahyadri landscape offers beautiful views and a peaceful atmosphere. Customers can include Brahmagiri in their Pune to Trimbakeshwar cab itinerary for a combined religious and nature-focused trip."
  },
  {
    title: "Kushavarta Kund",
    description: "Kushavarta Kund is a sacred water tank located near Trimbakeshwar Temple and holds significant importance for pilgrims visiting the Jyotirlinga. Devotees often include the kund as part of their temple visit and religious rituals. Garud Cab Service provides comfortable transportation for families and senior citizens visiting the important pilgrimage sites around Trimbakeshwar."
  },
  {
    title: "Nashik",
    description: "Nashik is a major religious and cultural city near Trimbakeshwar, known for temples, ghats, vineyards, and historic attractions. Travelers from Pune can combine Trimbakeshwar and Nashik in a single customized cab itinerary. Customers can choose a one-way or round-trip vehicle with flexible sightseeing stops and professional chauffeur assistance."
  },
  {
    title: "Panchavati",
    description: "Panchavati is a prominent religious area in Nashik associated with several temples and locations connected with the Ramayana tradition. Popular attractions include Ram Kund and nearby historic temples. Garud Cab Service can include Panchavati in a customized pilgrimage itinerary for customers traveling from Pune to Trimbakeshwar and Nashik."
  },
  {
    title: "Sita Gufa",
    description: "Sita Gufa is a well-known religious attraction in Panchavati and is traditionally associated with the Ramayana period. The cave and surrounding temple area attract devotees and tourists visiting Nashik. Travelers can conveniently visit Sita Gufa as part of a private cab journey covering Trimbakeshwar and other religious destinations."
  },
  {
    title: "Ram Kund",
    description: "Ram Kund is an important sacred bathing place on the Godavari River in Nashik and is visited by pilgrims throughout the year. Its religious significance makes it a common stop during Nashik pilgrimage tours. Customers booking a Pune to Trimbakeshwar cab can extend their itinerary to include Ram Kund and nearby temples."
  },
  {
    title: "Anjaneri Hills",
    description: "Anjaneri Hills is a scenic and spiritually significant destination near Nashik and Trimbakeshwar, associated with the traditional birthplace of Lord Hanuman. The hills offer a combination of religious importance and natural scenery. Garud Cab Service provides private transportation for travelers wishing to include Anjaneri in their customized journey."
  },
  {
    title: "Sula Vineyards",
    description: "Sula Vineyards is a well-known vineyard destination near Nashik offering scenic surroundings, vineyard experiences, and opportunities to explore the region's wine culture. Travelers who want to combine pilgrimage with leisure sightseeing can include the location in their itinerary. Customers can customize their cab booking for comfortable multi-stop travel around Nashik."
  },
  {
    title: "Pandavleni Caves",
    description: "Pandavleni Caves are ancient rock-cut Buddhist caves located near Nashik and are an interesting heritage attraction for history enthusiasts and travelers. The site offers views over the surrounding region and provides a different experience beyond religious sightseeing. Garud Cab Service can include Pandavleni Caves in a customized Pune to Trimbakeshwar travel plan."
  }
],




"services": [
{
"name": "Pune to Trimbakeshwar Cab",
"description": "Book Pune to Trimbakeshwar Cab for comfortable and convenient private transportation from Pune to the famous Trimbakeshwar temple town. Professional chauffeurs and well-maintained AC vehicles make the service suitable for devotees, families, tourists, and passengers planning a peaceful pilgrimage journey."
},
{
"name": "Pune to Trimbakeshwar Taxi",
"description": "Choose Pune to Trimbakeshwar Taxi for a comfortable intercity journey with convenient pickup from your preferred Pune location. Sedan, SUV, Innova, and other vehicle options can be arranged according to passenger count, luggage, travel timing, and pilgrimage requirements."
},
{
"name": "Cab from Pune to Trimbakeshwar",
"description": "Reserve a Cab from Pune to Trimbakeshwar for direct chauffeur-driven transportation to the temple destination. The service is suitable for families, senior citizens, devotees, and tourists looking for private travel with flexible pickup arrangements and convenient destination drop."
},
{
"name": "Taxi from Pune to Trimbakeshwar",
"description": "Book a Taxi from Pune to Trimbakeshwar for a comfortable point-to-point journey with experienced drivers. Spacious AC vehicles can be selected for individual travelers, families, and groups visiting Trimbakeshwar for religious, personal, or sightseeing purposes."
},
{
"name": "Pune to Trimbakeshwar Cab Service",
"description": "Choose Pune to Trimbakeshwar Cab Service for reliable private transportation with professional chauffeur assistance and comfortable vehicles. The service is suitable for temple visits, family pilgrimages, weekend travel, sightseeing, and planned religious journeys from Pune."
},
{
"name": "Pune to Trimbakeshwar Taxi Fare",
"description": "Check Pune to Trimbakeshwar Taxi Fare according to the selected vehicle category, pickup location, journey type, and travel requirements. Sedan, SUV, Innova, and larger options can be arranged for devotees and families seeking practical long-distance transportation."
},
{
"name": "Pune to Trimbakeshwar One Way Cab",
"description": "Book Pune to Trimbakeshwar One Way Cab for convenient point-to-point travel without requiring a return booking. This option is suitable for devotees, families, tourists, and passengers who need direct transportation from Pune to Trimbakeshwar."
},
{
"name": "Pune to Trimbakeshwar Round Trip Taxi",
"description": "Choose Pune to Trimbakeshwar Round Trip Taxi for a planned journey with return transportation included. The service is convenient for same-day temple visits, family pilgrimages, sightseeing trips, and travelers who prefer a private vehicle throughout their journey."
},
{
"name": "Pune to Trimbakeshwar Cab Booking",
"description": "Make Pune to Trimbakeshwar Cab Booking in advance to arrange convenient pickup and vehicle selection for your pilgrimage. Customers can choose suitable cars according to passenger count, luggage, preferred schedule, and one-way or round-trip travel requirements."
},
{
"name": "Cheap Pune to Trimbakeshwar Cab",
"description": "Book a Cheap Pune to Trimbakeshwar Cab for economical private transportation while maintaining comfortable travel conditions. Practical sedan and other vehicle options can be arranged for devotees, families, students, and budget-conscious travelers."
},
{
"name": "Best Pune to Trimbakeshwar Taxi",
"description": "Choose the Best Pune to Trimbakeshwar Taxi for comfortable pilgrimage travel supported by professional chauffeurs and well-maintained vehicles. The service is suitable for families, senior passengers, devotees, and tourists who prefer private transportation."
},
{
"name": "Sedan Pune to Trimbakeshwar Cab",
"description": "Book a Sedan Pune to Trimbakeshwar Cab for practical and comfortable travel for individuals, couples, and small families. The AC sedan provides convenient seating and luggage space for temple visits, personal journeys, and long-distance road travel."
},
{
"name": "SUV Pune to Trimbakeshwar Taxi",
"description": "Choose SUV Pune to Trimbakeshwar Taxi for spacious transportation with additional seating and luggage capacity. SUV travel is suitable for families, small groups, senior passengers, and devotees carrying luggage during a longer pilgrimage journey."
},
{
"name": "Innova Pune to Trimbakeshwar Cab",
"description": "Book Innova Pune to Trimbakeshwar Cab for spacious and comfortable transportation for families and groups. The vehicle offers practical seating and luggage capacity, making it suitable for pilgrimage travel, sightseeing, and private round-trip journeys."
},
{
"name": "Temple Cab Pune to Trimbakeshwar",
"description": "Choose Temple Cab Pune to Trimbakeshwar for convenient private transportation to one of Maharashtra's important pilgrimage destinations. Professional chauffeurs and comfortable vehicles make the service suitable for devotees, families, senior citizens, and religious groups."
},
{
"name": "Pune to Trimbakeshwar Shirdi Cab",
"description": "Book Pune to Trimbakeshwar Shirdi Cab for a convenient pilgrimage journey covering Trimbakeshwar and Shirdi. The service is suitable for families, devotees, senior passengers, and groups who want private transportation between important religious destinations."
},
{
"name": "Pune Trimbakeshwar Shirdi Tour Package",
"description": "Choose Pune Trimbakeshwar Shirdi Tour Package for planned pilgrimage transportation covering Trimbakeshwar and Shirdi. Comfortable chauffeur-driven vehicles can be arranged for families and groups according to their preferred travel schedule and sightseeing requirements."
},
{
"name": "Pune Shirdi Nashik Trimbakeshwar Cab",
"description": "Book Pune Shirdi Nashik Trimbakeshwar Cab for a multi-destination religious journey covering major pilgrimage locations in Maharashtra. The service provides private transportation suitable for devotees, families, senior citizens, and groups planning a customized temple tour."
},
{
"name": "Pune Trimbakeshwar Shani Shingnapur Tour",
"description": "Choose Pune Trimbakeshwar Shani Shingnapur Tour for a convenient religious circuit covering important temple destinations. A private chauffeur-driven vehicle provides flexible travel for families, devotees, and groups wishing to complete their pilgrimage according to their schedule."
},
{
"name": "Pune Bhimashankar Trimbakeshwar Cab",
"description": "Book Pune Bhimashankar Trimbakeshwar Cab for a private pilgrimage journey connecting two prominent Jyotirlinga destinations. The service is suitable for devotees, families, and groups looking for comfortable road transportation with flexible travel and sightseeing arrangements."
},
{
"name": "Pune Three Jyotirlinga Tour Package",
"description": "Choose Pune Three Jyotirlinga Tour Package for a planned religious road journey covering selected Jyotirlinga temples in Maharashtra. Comfortable vehicles with professional drivers can accommodate families and groups undertaking multi-day pilgrimage travel."
},
{
"name": "Pune Bhimashankar Trimbakeshwar Grishneshwar Cab",
"description": "Book Pune Bhimashankar Trimbakeshwar Grishneshwar Cab for a private multi-temple pilgrimage covering three important Jyotirlinga destinations. The service is suitable for devotees, families, senior passengers, and groups requiring comfortable long-distance transportation."
},
{
"name": "Pune Trimbakeshwar Saptashrungi Tour",
"description": "Choose Pune Trimbakeshwar Saptashrungi Tour for convenient private transportation to Trimbakeshwar and Saptashrungi pilgrimage destinations. The journey can be arranged for families and religious groups seeking flexible travel, temple visits, and comfortable road transportation."
},
{
"name": "Pune Nashik Trimbakeshwar Shirdi Two-Day Package",
"description": "Book Pune Nashik Trimbakeshwar Shirdi Two-Day Package for a convenient multi-destination pilgrimage covering Nashik, Trimbakeshwar, and Shirdi. The private cab service is suitable for families, devotees, and groups planning a structured two-day religious journey."
},
{
"name": "Pune Trimbakeshwar Shirdi Three-Day Cab",
"description": "Choose Pune Trimbakeshwar Shirdi Three-Day Cab for a comfortable extended pilgrimage journey with private transportation throughout the trip. The service provides flexibility for devotees, families, and groups visiting Trimbakeshwar, Shirdi, and nearby religious attractions."
},
{
"name": "Pune Maharashtra Pilgrimage Cab Package",
"description": "Book Pune Maharashtra Pilgrimage Cab Package for private transportation across multiple religious destinations in Maharashtra. Flexible vehicle options can be arranged for families, senior citizens, devotees, and groups planning customized temple tours over one or several days."
},
{
"name": "Hinjewadi to Trimbakeshwar Cab",
"description": "Choose Hinjewadi to Trimbakeshwar Cab for convenient private transportation from Hinjewadi to the Trimbakeshwar temple area. The service is suitable for IT professionals, families, devotees, and groups looking for direct chauffeur-driven pilgrimage travel."
},
{
"name": "Wakad to Trimbakeshwar Cab",
"description": "Book Wakad to Trimbakeshwar Cab for comfortable travel from Wakad to Trimbakeshwar with convenient pickup arrangements. Sedan, SUV, and Innova options can be selected for families, devotees, and passengers planning temple visits."
},
{
"name": "Baner to Trimbakeshwar Cab",
"description": "Choose Baner to Trimbakeshwar Cab for direct private transportation from Baner to the Trimbakeshwar pilgrimage destination. Professional drivers and comfortable AC vehicles make the service suitable for families, corporate passengers, and devotees."
},
{
"name": "Aundh to Trimbakeshwar Cab",
"description": "Book Aundh to Trimbakeshwar Cab for convenient chauffeur-driven travel from Aundh to Trimbakeshwar. The service is suitable for individuals, families, senior citizens, and religious groups requiring comfortable private transportation for temple visits."
},
{
"name": "Kothrud to Trimbakeshwar Cab",
"description": "Choose Kothrud to Trimbakeshwar Cab for comfortable private travel with pickup from Kothrud and direct transportation to Trimbakeshwar. The service can accommodate families and groups with suitable vehicles based on passenger and luggage requirements."
},
{
"name": "Hadapsar to Trimbakeshwar Cab",
"description": "Book Hadapsar to Trimbakeshwar Cab for convenient intercity pilgrimage transportation from Hadapsar. Comfortable AC vehicles and professional chauffeurs provide practical travel for devotees, families, tourists, and passengers planning religious journeys."
},
{
"name": "Kharadi to Trimbakeshwar Cab",
"description": "Choose Kharadi to Trimbakeshwar Cab for direct private transportation from Kharadi to the temple destination. The service is suitable for IT professionals, families, devotees, and groups requiring a comfortable vehicle for long-distance pilgrimage travel."
},
{
"name": "Viman Nagar to Trimbakeshwar Cab",
"description": "Book Viman Nagar to Trimbakeshwar Cab for convenient private transportation with pickup from Viman Nagar. Sedan, SUV, and larger vehicles can be arranged for families, devotees, tourists, and groups carrying luggage."
},
{
"name": "Swargate to Trimbakeshwar Cab",
"description": "Choose Swargate to Trimbakeshwar Cab for comfortable road transportation from central Pune to Trimbakeshwar. The service is suitable for devotees, families, senior passengers, and groups planning temple visits with private chauffeur assistance."
},
{
"name": "Shivajinagar to Trimbakeshwar Cab",
"description": "Book Shivajinagar to Trimbakeshwar Cab for convenient private travel from Shivajinagar to Trimbakeshwar. Professional chauffeurs and comfortable vehicles make the journey suitable for religious trips, family travel, and sightseeing requirements."
},
{
"name": "PCMC to Trimbakeshwar Cab",
"description": "Choose PCMC to Trimbakeshwar Cab for private pilgrimage transportation from Pimpri-Chinchwad and surrounding PCMC areas. Vehicle options can be selected according to passenger count and luggage for a comfortable journey to Trimbakeshwar."
},
{
"name": "Pimpri-Chinchwad to Trimbakeshwar Cab",
"description": "Book Pimpri-Chinchwad to Trimbakeshwar Cab for direct chauffeur-driven travel from Pimpri-Chinchwad to the temple destination. The service is suitable for families, devotees, senior citizens, and groups looking for comfortable private transportation."
},
{
"name": "Pune Airport to Trimbakeshwar Cab",
"description": "Choose Pune Airport to Trimbakeshwar Cab for convenient airport pickup and direct transportation to the pilgrimage destination. The service is suitable for devotees, tourists, families, and passengers arriving in Pune who need private long-distance travel."
},
{
"name": "Pune Railway Station to Trimbakeshwar Cab",
"description": "Book Pune Railway Station to Trimbakeshwar Cab for convenient pickup from Pune Railway Station and direct travel to Trimbakeshwar. Comfortable AC vehicles are suitable for passengers arriving by train and continuing their pilgrimage with family or groups."
}
],
"tableData": [
["Pune to Trimbakeshwar Cab", "Pune to Trimbakeshwar Taxi"],
["Cab from Pune to Trimbakeshwar", "Taxi from Pune to Trimbakeshwar"],
["Pune to Trimbakeshwar Cab Service", "Pune to Trimbakeshwar Taxi Fare"],
["Pune to Trimbakeshwar One Way Cab", "Pune to Trimbakeshwar Round Trip Taxi"],
["Pune to Trimbakeshwar Cab Booking", "Cheap Pune to Trimbakeshwar Cab"],
["Best Pune to Trimbakeshwar Taxi", "Sedan Pune to Trimbakeshwar Cab"],
["SUV Pune to Trimbakeshwar Taxi", "Innova Pune to Trimbakeshwar Cab"],
["Temple Cab Pune to Trimbakeshwar", "Pune to Trimbakeshwar Shirdi Cab"],
["Pune Trimbakeshwar Shirdi Tour Package", "Pune Shirdi Nashik Trimbakeshwar Cab"],
["Pune Trimbakeshwar Shani Shingnapur Tour", "Pune Bhimashankar Trimbakeshwar Cab"],
["Pune Three Jyotirlinga Tour Package", "Pune Bhimashankar Trimbakeshwar Grishneshwar Cab"],
["Pune Trimbakeshwar Saptashrungi Tour", "Pune Nashik Trimbakeshwar Shirdi Two-Day Package"],
["Pune Trimbakeshwar Shirdi Three-Day Cab", "Pune Maharashtra Pilgrimage Cab Package"],
["Hinjewadi to Trimbakeshwar Cab", "Wakad to Trimbakeshwar Cab"],
["Baner to Trimbakeshwar Cab", "Aundh to Trimbakeshwar Cab"],
["Kothrud to Trimbakeshwar Cab", "Hadapsar to Trimbakeshwar Cab"],
["Kharadi to Trimbakeshwar Cab", "Viman Nagar to Trimbakeshwar Cab"],
["Swargate to Trimbakeshwar Cab", "Shivajinagar to Trimbakeshwar Cab"],
["PCMC to Trimbakeshwar Cab", "Pimpri-Chinchwad to Trimbakeshwar Cab"],
["Pune Airport to Trimbakeshwar Cab", "Pune Railway Station to Trimbakeshwar Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Trimbakeshwar Cab Service for Pilgrimage Travel",
    WhyChoosedescription: "A private cab is a convenient option for devotees and families travelling from Pune to Trimbakeshwar for temple visits, religious journeys, spiritual trips, family occasions, and planned sightseeing."
  },
  {
    WhyChooseheading: "Direct Pickup from Your Preferred Pune Location",
    WhyChoosedescription: "Passengers can begin their journey from a home, hotel, office, residential society, railway station area, or another convenient location in Pune and travel directly toward Trimbakeshwar."
  },
  {
    WhyChooseheading: "Comfortable Travel for Families & Devotees",
    WhyChoosedescription: "Families, senior citizens, couples, and groups can select a suitable vehicle according to passenger count, luggage requirements, and comfort preferences for the religious journey."
  },
  {
    WhyChooseheading: "Convenient for Temple Darshan Plans",
    WhyChoosedescription: "Travellers visiting Trimbakeshwar Jyotirlinga can plan their cab journey around their preferred darshan schedule, sightseeing requirements, and overall pilgrimage itinerary."
  },
  {
    WhyChooseheading: "One-Way Cab for Direct Travel",
    WhyChoosedescription: "Those travelling to Trimbakeshwar for a temple visit, family function, personal work, or onward journey can choose a one-way cab when a return vehicle is not required."
  },
  {
    WhyChooseheading: "Round-Trip Cab for Pilgrimage Tours",
    WhyChoosedescription: "A round-trip cab is suitable for devotees planning to complete their Trimbakeshwar visit and return to Pune in the same private vehicle according to their preferred schedule."
  },
  {
    WhyChooseheading: "Useful for Religious & Family Trips",
    WhyChoosedescription: "Private road transportation works well for group pilgrimages, family temple visits, spiritual tours, and planned trips where travelling together provides greater convenience."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Provide your Pune pickup point, Trimbakeshwar destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip requirement for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Trimbakeshwar Cab Service?",
    answer: "Yes, Garud Cab Service provides private Pune to Trimbakeshwar cab services for devotees, families, couples, senior citizens, groups, and passengers planning religious or personal trips."
  },
  {
    question: "Can I book a one-way cab from Pune to Trimbakeshwar?",
    answer: "Yes, one-way cab service can be arranged for passengers who require direct transportation from Pune to Trimbakeshwar or their preferred destination nearby."
  },
  {
    question: "Can I book a round-trip cab for Trimbakeshwar?",
    answer: "Yes, round-trip cab arrangements can be planned for temple darshan, pilgrimage trips, family visits, sightseeing, and other journeys requiring transportation back to Pune."
  },
  {
    question: "Is Pune to Trimbakeshwar cab suitable for senior citizens?",
    answer: "Yes, private cab travel can be a convenient option for senior citizens and families who prefer direct transportation with comfortable seating and fewer travel changes."
  },
  {
    question: "Can I book a cab for Trimbakeshwar Jyotirlinga Darshan?",
    answer: "Yes, a private cab can be arranged for devotees planning a visit to Trimbakeshwar Jyotirlinga and other nearby locations according to their pilgrimage itinerary."
  },
  {
    question: "Can families travel together from Pune to Trimbakeshwar?",
    answer: "Yes, families and groups can select a suitable vehicle based on passenger numbers, luggage requirements, and desired comfort for the pilgrimage journey."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another preferred location in Pune."
  },
  {
    question: "Can I carry luggage in the Pune to Trimbakeshwar cab?",
    answer: "Yes, passengers can carry luggage according to the available space in the selected vehicle. Larger luggage requirements should be communicated during booking."
  },
  {
    question: "Can I use the cab for nearby sightseeing?",
    answer: "Yes, the private cab can be used for planned sightseeing around Trimbakeshwar and nearby destinations depending on your itinerary and selected trip arrangement."
  },
  {
    question: "How can I book a Pune to Trimbakeshwar Cab Service?",
    answer: "Share your Pune pickup location, Trimbakeshwar destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip preference with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Vinay Kulkarni",
    feedback: "Our family travelled from Pune to Trimbakeshwar for temple darshan and selected a private cab. Travelling together was convenient, especially for our elderly family members.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Patil",
    feedback: "We arranged a round-trip cab for our Trimbakeshwar pilgrimage. The private vehicle made it easier to follow our darshan schedule and travel together as a family.",
    rating: 5
  }
];















  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Trimbakeshwar Cab Service",
  "image": "https://garudcabs.com/assets/images/pune-to-trimbakeshwar-cab-service.webp",
  "description": "Book Pune to Trimbakeshwar Cab Service with Garud Cab for safe, comfortable, and reliable pilgrimage travel. Get Pune to Trimbakeshwar cab and taxi services for one way trips, round trips, temple visits, family journeys, and religious tours. Choose Sedan, Ertiga, SUV, Innova, and Innova Crysta vehicles with convenient pickup and drop facilities for a comfortable journey from Pune to Trimbakeshwar.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-trimbakeshwar-cab-service"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune to Trimbakeshwar Cab Service | Taxi & Darshan Cab | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Trimbakeshwar Cab Service with Garud Cab for comfortable and reliable pilgrimage travel. Get one way, round trip, temple visit, and religious tour cab services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Pune to Trimbakeshwar Cab, Pune to Trimbakeshwar Taxi, Pune to Trimbakeshwar Cab Service, Pune to Trimbakeshwar Taxi Service, Pune to Trimbakeshwar One Way Cab, Pune to Trimbakeshwar Round Trip Cab, Pune to Trimbakeshwar Cab Booking, Pune to Trimbakeshwar Darshan Cab, Pune to Trimbakeshwar Temple Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/89.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetotrimbkeshwarcab;